import React from 'react'

export default function TrackerCaseStudy({ children }) {
  return (
    <section className="tracker-case-study">
      {children}
    </section>
  )
}
